module.exports = __webpack_public_path__ + "static/ok-4dc1e993bc1f96a1f563a99bd45f6cef.png";